import createTransform from 'redux-persist/es/createTransform'
import type { AuthState } from '../types/auth.types'

export const stripPersistedAuthTenantTransform = createTransform(
  (inboundState: AuthState | undefined) => {
    if (!inboundState || typeof inboundState !== 'object') return inboundState
    return { ...inboundState, selectedClientTenant: null }
  },
  (outboundState: AuthState | undefined) => {
    if (!outboundState || typeof outboundState !== 'object') return outboundState
    return { ...outboundState, selectedClientTenant: null }
  },
  { whitelist: ['authUser'] }
)
